import React, { Component } from "react";

import UI from "../../../actions/ui-helper";
import API from "../../../actions/api-helper";

class CadastroProcedimentoValor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usuarioId: 0,
      filtroUsuario: 1, // 0 - TODOS, 1 - ATIVOS, 2 - INATIVOS
      usuarios: []
    };

    this.handleChange = this.handleChange.bind(this);
    this.incluirValor = this.incluirValor.bind(this);
  }

  componentDidUpdate() {
    UI.dataTable("#data-table");
  }

  componentDidMount() {
    API.get("/usuarios/ativos")
      .then(
        (json) => {
          let lista = [];
          json.data.forEach(usuario => {
            lista.push({
              usuarioId: usuario.id,
              usuarioNome: usuario.nome,
              usuarioInativo: usuario.inativo,
              unidade: 1,
              valorPagar: "0.00"
            })
          });
          this.setState({ usuarios: lista });
        }
      )
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleChangeValor(event, valor, i) {
    valor[event.target.name] = event.target.value;
    this.props.onAlterarValor(valor, i);
  }

  incluirValor() {
    let listaAdd = [];
    let usuarioId = parseInt(this.state.usuarioId);
    if (usuarioId === 0) {
      listaAdd = this.state.usuarios.filter((usuario) => {
        let id = this.props.valores.findIndex(function (valor) {
          return usuario.usuarioId === valor.usuarioId;
        });
        return id < 0;
      })
    }
    else {
      let idx = this.state.usuarios.findIndex(function (usuario) {
        return usuarioId === usuario.usuarioId;
      });
      listaAdd.push(this.state.usuarios[idx]);
    }
    this.setState({ usuarioId: 0 });
    this.props.onIncluirValor(listaAdd);
  }

  render() {
    if (this.state.usuarios.length === 0) return false;
    let filtroUsuario = parseInt(this.state.filtroUsuario);
    return (
      <div className="col-md-12 grid-margin">
        <div className="card">
          <div className="card-body">
            <div className="form-group row">
              <div className="col-md-6">
                <h4 className="card-title">PROFISSIONAIS VINCULADOS</h4>
              </div>
              <div className="col-md-2">
                <select
                  name="filtroUsuario"
                  className="form-control"
                  value={this.state.filtroUsuario}
                  onChange={this.handleChange}
                >
                  <option value={0}>TODOS</option>
                  <option value={1}>ATIVOS</option>
                  <option value={2}>INATIVOS</option>
                </select>
              </div>
              <div className="col-md-4">
                <div className="input-group">
                  <select
                    name="usuarioId"
                    className="form-control"
                    value={this.state.usuarioId}
                    onChange={this.handleChange}
                  >
                    <option value={0}>TODOS</option>
                    {this.state.usuarios.map((usuario, i) => {
                      // Não permitir adição de usuários repetidos
                      let id = this.props.valores.findIndex(
                        function (valor) { return usuario.usuarioId === valor.usuarioId; });
                      if (id >= 0) return false;
                      // Renderiza a opção
                      return <option
                        key={i}
                        value={usuario.usuarioId}
                      >
                        {usuario.usuarioNome}
                      </option>
                    })}
                  </select>
                  <div className="input-group-append">
                    <button
                      className="btn btn-xs btn-primary"
                      type="button"
                      onClick={this.incluirValor}
                    >
                      Incluir
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {this.props.valores.length > 0 &&
              <div className="form-group row">
                <div className="col-md-12 table-responsive">
                  <table id="data-table" className="table">
                    <thead>
                      <tr>
                        <th></th>
                        <th style={{ width: "50%" }}>Nome</th>
                        <th>Unidade Pagamento</th>
                        <th>Valor Pagar (R$)</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.props.valores.map(
                        function (valor, i) {
                          if (valor.usuarioInativo === (filtroUsuario === 2) || (filtroUsuario === 0))
                            return (
                              <tr key={valor.usuarioId}>
                                <td>
                                  <i className="icon icon-user" />
                                </td>
                                <td>{valor.usuarioNome}</td>
                                <td>
                                  <select
                                    disabled={valor.usuarioInativo}
                                    name="unidade"
                                    className="form-control"
                                    value={valor.unidade}
                                    onChange={(event) => this.handleChangeValor(event, valor, i)}
                                  >
                                    <option value={1}>HORA</option>
                                    <option value={2}>LANÇAMENTO</option>
                                  </select>
                                </td>
                                <td>
                                  <input
                                    disabled={valor.usuarioInativo}
                                    name="valorPagar"
                                    type="number"
                                    step="any"
                                    className="form-control"
                                    value={valor.valorPagar}
                                    onChange={(event) => this.handleChangeValor(event, valor, i)}
                                  />
                                </td>
                                <td className="text-right">
                                  <button
                                    type="button"
                                    onClick={() => {
                                      this.props.onRemoverValor(i);
                                    }}
                                    className="btn btn-remove icon-btn"
                                  >
                                    <i className="fa fa-times"></i>
                                  </button>
                                </td>
                              </tr>
                            );
                        }.bind(this)
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            }
            <div className="row">
              <div className="col-md-12 text-right">
                <button type="submit" className="btn btn-success mb-2">
                  Concluido
                    </button>
              </div></div>
          </div>
        </div>
      </div>
    );
  }
}

export default CadastroProcedimentoValor;
